<sgt-multi-select
  [settings]="settings"
  [options]="options"
  [(ngModel)]="idsOperacoesVenda"
  (ngModelChange)="onChangeOperacoesVenda()"
  (search)="onSearch()"
>
</sgt-multi-select>
